class SimplePopup {
    constructor(element) {
        if (!element) return;

        this.element = element;
        this.closeBtn = this.element.querySelector(".js-simple-popup-close");

        this._init();
    }

    _init() {
        this.element.style.transition = "transform 0.3s linear, visibility 0.3s linear";
        this._initClosers();
    }

    _initListeners() {
        const compareIcons = document.querySelectorAll(".card-actions__item--compare");

        if (compareIcons) {
            compareIcons.forEach((icon) => {
                icon.addEventListener("click", () => {
                    this._open();
                });
            });
        }
    }

    _open() {
        this.element.classList.add("active");
        this._initClosers();
    }

    _initClosers() {
        this.closeBtn.addEventListener("click", () => {
            this._close();
        });

        ["touchstart"].forEach((eventType) => {
            document.addEventListener(eventType, (evt) => {
                if (!this.element.contains(evt.target)) {
                    this._close();
                }
            });
        });
    }

    _close() {
        if (this.element.classList.contains("active")) {
            this.element.removeAttribute("style");
            this.element.classList.remove("active");

            setTimeout(() => {
                this.element.style.transition = "transform 0.3s linear, visibility 0.3s linear";
            }, "100");
        }
    }
}

const popup = document.querySelector(".js-simple-popup");

if (popup) {
    window.addEventListener("load", () => new SimplePopup(popup));
}
